import React, {useState} from 'react';

import {
    Card,
    TranslatedString,
    Checkbox,
    PrimaryButton,
    InputField
} from '@bosch/bt-ui';

import { v4 as uuidv4 } from 'uuid';
import './RpsControlFields.css';
import ConfirmDialog from '../../../components/ConfirmDialog';
import withErrorHandler from '../../../components/ErrorHandler';


const RpsControlFields = (props) => {
    const {
        formValues,
        updateFormValues,
        mode
    } = props;
    const [openConfirm, setConfirmOpen] = useState(false);
    //const [isISKUpdate, setISKUpdate] = useState(false);
    const onOpenModal = () =>{
        if(mode=="update"){
            //only in update mode ask to confirm the change ISK
            setConfirmOpen(true);
            //setISKUpdate(true);
        }
        else{
            //In create mode, directly generate ISK
            generateServiceKey();
        }
        
    } 
    const generateServiceKey = () => {
        let uuid = uuidv4();
        setConfirmOpen(false);
        updateFormValues({
            fieldName: "onlineServiceKey",
            value: uuid
        });
    }
    const isButtonEnabled = mode === "update";
    console.log(formValues);
    return (
		<Card
			htmlAttributes={{
				id: "rpscontrol",
				className: 'firmware-overview-section'
			}}
		>
			<div className="caption font-large">Rps Control Settings</div>
            <div className="filter-checkboxes">
                <Checkbox
                    fieldName="allowUploadofPanelInfo"
                    label="Allow RPS to publish panel information"
                    htmlAttributes={{
                        onChange: updateFormValues,
                        checked: formValues['allowUploadofPanelInfo'] ?? true
                    }}
                />

                <Checkbox
                    fieldName="useConnectorService"
                    label="Use Cloud for Connection Info"
                    htmlAttributes={{
                        onChange: updateFormValues,
                        checked: formValues['useConnectorService'] ?? true
                    }}
                />

                <Checkbox
                    fieldName="allowCBSAuthforClouldPanelConnections"
                    label="Permit Legacy CBS Cloud Panel Access"
                    htmlAttributes={{
                        onChange: updateFormValues,
                        checked: formValues['allowCBSAuthforClouldPanelConnections'] ?? true
                    }}
                />
            </div>
			<div className="font-medium">Installer Service Key</div>
			<div className="online-service-key">
				<div className="rps-input-field">
					<InputField
                        fieldName="onlineServiceKey"
						htmlAttributes={{
							disabled: true,
							onChange: updateFormValues,
							value: formValues.onlineServiceKey ?? ""
						}}
					/>
				</div>
				{isButtonEnabled && (
                <div className="generate-uuid-key">
					<PrimaryButton onClick={onOpenModal}>
						Generate Installer Service Key
					</PrimaryButton>
                    <ConfirmDialog openConfirm={openConfirm} descTranslatedId="isk-update-warning" setConfirmOpen={setConfirmOpen} onConfirm={generateServiceKey} />
				</div>
                  )}
            </div>
            <div className="font-small"><TranslatedString stringId="note-isk" /></div>
        </Card>
    );
};

export default withErrorHandler(React.memo(RpsControlFields));